module.exports = __webpack_public_path__ + "img/ione10.c2c244af.png";